import AppConst from '../../constants/app.constant';
import { saveToLocalStorage } from './saveToLocalStorage';

export const setKeyValueInLocalStorage = function (key, value) {
  if (key && value) {
    saveToLocalStorage(AppConst.localstorageConf.prefix + key, value);
  }
};
